import {
	Box,
	Breakpoint,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography
} from '@mui/material';
import React, { BaseSyntheticEvent } from 'react';
import { ButtonColorProps } from 'types/common';

interface IApprovalDialogProps {
	onApprove: (e: BaseSyntheticEvent) => void;
	onCancel: (e: BaseSyntheticEvent) => void;
	title: string;
	question: React.ReactNode;
	approveText: string;
	cancelText: string;
	color?: ButtonColorProps;
	maxWidth?: Breakpoint | false;
	variant?: 'contained' | 'text' | 'outlined';
	horizontalButtons?: boolean;
	approveIcon?: React.ReactNode;
	headerIcon?: React.ReactNode;
}

const ApprovalDialog = ({
	onApprove,
	onCancel,
	title,
	question,
	approveText,
	cancelText,
	color,
	maxWidth,
	variant,
	horizontalButtons,
	approveIcon,
	headerIcon
}: IApprovalDialogProps) => (
	<Dialog
		data-testid="approval-dialog"
		disableRestoreFocus
		open
		maxWidth={maxWidth}
		onClose={onCancel}
		sx={{
			minHeight: '1000px'
		}}
	>
		<DialogTitle>
			<Box display="flex" flexDirection="row">
				{headerIcon && (
					<Box
						display="flex"
						flexDirection="row"
						alignItems="center"
						pr={1}
						data-testid="approval-dialog-header-icon"
					>
						{headerIcon}
					</Box>
				)}
				<Typography variant="h6">{title}</Typography>
			</Box>
		</DialogTitle>
		<DialogContent
			sx={{
				minHeight: '80px',
				whiteSpace: 'break-spaces'
			}}
		>
			{question}
		</DialogContent>
		<DialogActions
			sx={
				horizontalButtons
					? {
							flexDirection: 'column-reverse',
							alignItems: 'stretch',
							mx: 1,
							height: 110,
							justifyContent: 'space-evenly'
					  }
					: {}
			}
		>
			<Button onClick={onCancel} data-testid="approval-dialog-cancel-button">
				{cancelText}
			</Button>
			<Button
				autoFocus
				onClick={onApprove}
				data-testid="approval-dialog-approve-button"
				color={color}
				variant={variant}
				startIcon={approveIcon}
			>
				{approveText}
			</Button>
		</DialogActions>
	</Dialog>
);

ApprovalDialog.defaultProps = {
	color: 'inherit',
	variant: 'text',
	maxWidth: 'xs',
	horizontalButtons: false,
	approveIcon: undefined,
	headerIcon: undefined
};

export default ApprovalDialog;
export type { IApprovalDialogProps };
